import React from "react";
import { NavLink } from "react-router-dom";

/**
 * This topbar:
 * 1. Is fixed at the top (z-50).
 * 2. Has a translucent black overlay (bg-black/20).
 * 3. Blurs the background behind it (backdrop-blur-md).
 * 4. Aligns the nav links to the right.
 * 5. Underlines the active and hovered link.
 */
const TopBar = () => {
  return (
    <nav
      className="
        fixed
        top-0
        left-0
        w-full
        z-50
        py-4
        px-6
        text-white
        flex
        justify-end
        items-center
        bg-black/20
        backdrop-blur-md
        text-xl
      "
    >
      <ul className="flex space-x-6">
        {/* Home */}
        <li>
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              (isActive ? "underline" : "") + " hover:underline transition-all"
            }
          >
            Home
          </NavLink>
        </li>

        {/* Exhibition */}
        <li>
          <NavLink
            to="/exhibition"
            className={({ isActive }) =>
              (isActive ? "underline" : "") + " hover:underline transition-all"
            }
          >
            Exhibition
          </NavLink>
        </li>

        {/* Contact */}
        <li>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              (isActive ? "underline" : "") + " hover:underline transition-all"
            }
          >
            Contact
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default TopBar;
